import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m7.21 23.75 12.47-11a1.06 1.06 0 0 0 0-1.54L7.21.25A1 1 0 0 0 6.48 0a1 1 0 0 0-.69.36L4.24 2.21A1 1 0 0 0 4 3a1 1 0 0 0 .35.69l9.45 8.17a.27.27 0 0 1 0 .38l-9.45 8.12a1 1 0 0 0-.35.69 1 1 0 0 0 .23.74l1.56 1.85a1 1 0 0 0 .69.36 1 1 0 0 0 .73-.25"
    }, null, -1)
  ]));
}
const arrowChevronRight = { render };
export {
  arrowChevronRight as default,
  render
};
//# sourceMappingURL=arrow-chevron-right.svg.js.map
